import objectPath from "object-path";
import merge from "deepmerge";
import layoutConfig from "@/core/config/DefaultLayoutConfig";
import LayoutConfig from "@/core/config/LayoutConfigTypes";
import { Actions, Mutations } from "@/store/enums/store.enums";
import { Action, Mutation, Module, VuexModule } from "vuex-module-decorators";

interface StoreInfo {
  config: LayoutConfig;
  initial: LayoutConfig;
}

@Module
export default class ConfigModule extends VuexModule implements StoreInfo {
  config: LayoutConfig = layoutConfig;
  initial: LayoutConfig = layoutConfig;

  sidebarStateExpand = false;

  @Mutation
  [Mutations.MUTATE_SIDEBAR_STATE](payload) {
    this.sidebarStateExpand = payload;
  }

  @Action
  [Actions.SET_SIDEBAR_STATE](payload) {
    this.context.commit(Mutations.MUTATE_SIDEBAR_STATE, payload);
  }

  /**
   * Get config from layout config
   * @returns {function(path, defaultValue): *}
   */
  get layoutConfig() {
    return (path, defaultValue) => {
      return objectPath.get(this.config, path, defaultValue);
    };
  }

  @Mutation
  [Mutations.SET_LAYOUT_CONFIG](payload: LayoutConfig): void {
    this.config = payload;
  }

  @Mutation
  [Mutations.RESET_LAYOUT_CONFIG]() {
    this.config = Object.assign({}, this.initial);
  }

  @Mutation
  [Mutations.OVERRIDE_LAYOUT_CONFIG](): void {
    this.config = this.initial = Object.assign(
      {},
      this.initial,
      JSON.parse(window.localStorage.getItem("config") || "{}")
    );
  }

  @Mutation
  [Mutations.OVERRIDE_PAGE_LAYOUT_CONFIG](payload: LayoutConfig): void {
    this.config = merge(this.config, payload);
  }
}
